import MemberCenter from './member-center'
export default MemberCenter